import React from 'react';
import PropTypes from 'prop-types';

const Caution = ({ fill = '#E02020', width, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    fill="none"
    width={width}
    style={style}
  >
    <path
      d="M8.5 15a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
      fill={fill}
    />
    <path
      d="M7.502 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM7.6 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.6 4.995Z"
      fill={fill}
    />
  </svg>
);

Caution.defaultProps = {
  fill: '#E02020',
  width: '16px',
  style: undefined,
};

Caution.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
};

export default Caution;
